export const EXTRA = {
  en: {
    journey: {
      title: "Your Finnish journey", sub: "Travel from Helsinki to Lapland — one lesson at a time.",
      here: "You are here", start: "Start", review: "Review", done: "done",
      A1: "Helsinki & the Archipelago", A1sub: "A1 · Your first steps in Finnish",
      A2: "The Lake District", A2sub: "A2 · Everyday Finnish life",
      B1: "Lapland", B1sub: "B1 · Sound fluent and natural",
      search: "Search lessons…", questions: "questions",
    },
    qx: {
      modeTitle: "Choose your quiz", quick: "Quick round", quickDesc: "10 random questions — different every time.",
      full: "Full challenge", fullDesc: "Every question in this chapter.", questions: "questions", start: "Start",
      combo: "combo", xp: "XP", mc: "Multiple choice", tf: "True or false", fill: "Fill in the blank",
      translate: "Translate into Finnish", tTrue: "True", tFalse: "False", review: "Review your mistakes",
      noMistakes: "No mistakes — täydellistä!", yourAnswer: "Your answer", best: "Best", keys: "Tip: press 1–4 to choose, Enter to check",
      earned: "XP earned", bestCombo: "Best combo", grouped: "Quizzes by level",
    },
    gx: {
      xp: "Total XP", rank: "Rank", nextRank: "to next rank", achievements: "Achievements",
      r0: "Uusi tulokas · Newcomer", r1: "Oppija · Learner", r2: "Puhuja · Speaker", r3: "Sisu-mestari · Sisu Master", r4: "Suomen tähti · Finnish Star",
      a_first: "First lesson", a_first_d: "Complete your first lesson",
      a_ten: "Ten lessons", a_ten_d: "Complete 10 lessons",
      a_perfect: "Perfect score", a_perfect_d: "Get 100% in any quiz",
      a_streak: "On fire", a_streak_d: "Reach a 3-day streak",
      a_words: "Word collector", a_words_d: "Learn 25 words",
      a_a1: "A1 complete", a_a1_d: "Finish every A1 lesson",
    },
  },
  bn: {
    journey: {
      title: "আপনার ফিনিশ যাত্রা", sub: "হেলসিঙ্কি থেকে ল্যাপল্যান্ড — এক এক করে পাঠ।",
      here: "আপনি এখানে", start: "শুরু", review: "পুনরায় দেখুন", done: "সম্পন্ন",
      A1: "হেলসিঙ্কি ও দ্বীপপুঞ্জ", A1sub: "A1 · ফিনিশে আপনার প্রথম পদক্ষেপ",
      A2: "হ্রদ অঞ্চল", A2sub: "A2 · দৈনন্দিন ফিনিশ জীবন",
      B1: "ল্যাপল্যান্ড", B1sub: "B1 · সাবলীল ও স্বাভাবিক শোনান",
      search: "পাঠ খুঁজুন…", questions: "প্রশ্ন",
    },
    qx: {
      modeTitle: "আপনার কুইজ বেছে নিন", quick: "দ্রুত রাউন্ড", quickDesc: "১০টি এলোমেলো প্রশ্ন — প্রতিবার ভিন্ন।",
      full: "সম্পূর্ণ চ্যালেঞ্জ", fullDesc: "এই অধ্যায়ের সব প্রশ্ন।", questions: "প্রশ্ন", start: "শুরু",
      combo: "কম্বো", xp: "XP", mc: "বহুনির্বাচনী", tf: "সত্য না মিথ্যা", fill: "শূন্যস্থান পূরণ",
      translate: "ফিনিশে অনুবাদ করুন", tTrue: "সত্য", tFalse: "মিথ্যা", review: "আপনার ভুলগুলো দেখুন",
      noMistakes: "কোনো ভুল নেই — täydellistä!", yourAnswer: "আপনার উত্তর", best: "সেরা", keys: "টিপ: বেছে নিতে ১–৪ চাপুন, যাচাই করতে Enter",
      earned: "অর্জিত XP", bestCombo: "সেরা কম্বো", grouped: "স্তর অনুযায়ী কুইজ",
    },
    gx: {
      xp: "মোট XP", rank: "পদমর্যাদা", nextRank: "পরবর্তী পদ পর্যন্ত", achievements: "অর্জনসমূহ",
      a_first: "প্রথম পাঠ", a_first_d: "আপনার প্রথম পাঠ শেষ করুন",
      a_ten: "দশটি পাঠ", a_ten_d: "১০টি পাঠ শেষ করুন",
      a_perfect: "নিখুঁত স্কোর", a_perfect_d: "যেকোনো কুইজে ১০০%",
      a_streak: "ধারাবাহিক", a_streak_d: "৩ দিনের স্ট্রিক",
      a_words: "শব্দ সংগ্রাহক", a_words_d: "২৫টি শব্দ শিখুন",
      a_a1: "A1 সম্পূর্ণ", a_a1_d: "সব A1 পাঠ শেষ করুন",
    },
  },
  hi: {
    journey: {
      title: "आपकी फ़िनिश यात्रा", sub: "हेलसिंकी से लैपलैंड तक — एक-एक पाठ।",
      here: "आप यहाँ हैं", start: "शुरू करें", review: "दोहराएँ", done: "पूर्ण",
      A1: "हेलसिंकी और द्वीपसमूह", A1sub: "A1 · फ़िनिश में आपके पहले कदम",
      A2: "झीलों का क्षेत्र", A2sub: "A2 · रोज़मर्रा का फ़िनिश जीवन",
      B1: "लैपलैंड", B1sub: "B1 · धाराप्रवाह और स्वाभाविक बोलें",
      search: "पाठ खोजें…", questions: "प्रश्न",
    },
    qx: {
      modeTitle: "अपना क्विज़ चुनें", quick: "त्वरित राउंड", quickDesc: "10 यादृच्छिक प्रश्न — हर बार अलग।",
      full: "पूरी चुनौती", fullDesc: "इस अध्याय के सभी प्रश्न।", questions: "प्रश्न", start: "शुरू करें",
      combo: "कॉम्बो", xp: "XP", mc: "बहुविकल्पीय", tf: "सही या गलत", fill: "रिक्त स्थान भरें",
      translate: "फ़िनिश में अनुवाद करें", tTrue: "सही", tFalse: "गलत", review: "अपनी गलतियाँ देखें",
      noMistakes: "कोई गलती नहीं — täydellistä!", yourAnswer: "आपका उत्तर", best: "सर्वश्रेष्ठ", keys: "सुझाव: चुनने के लिए 1–4, जाँचने के लिए Enter",
      earned: "अर्जित XP", bestCombo: "सर्वश्रेष्ठ कॉम्बो", grouped: "स्तर के अनुसार क्विज़",
    },
    gx: {
      xp: "कुल XP", rank: "रैंक", nextRank: "अगली रैंक तक", achievements: "उपलब्धियाँ",
      a_first: "पहला पाठ", a_first_d: "अपना पहला पाठ पूरा करें",
      a_ten: "दस पाठ", a_ten_d: "10 पाठ पूरे करें",
      a_perfect: "पूर्ण अंक", a_perfect_d: "किसी भी क्विज़ में 100%",
      a_streak: "लगातार", a_streak_d: "3 दिन की स्ट्रीक",
      a_words: "शब्द संग्राहक", a_words_d: "25 शब्द सीखें",
      a_a1: "A1 पूर्ण", a_a1_d: "सभी A1 पाठ पूरे करें",
    },
  },
  ne: {
    journey: {
      title: "तपाईंको फिनिस यात्रा", sub: "हेलसिंकीदेखि ल्यापल्यान्डसम्म — एक-एक पाठ।",
      here: "तपाईं यहाँ हुनुहुन्छ", start: "सुरु गर्नुहोस्", review: "दोहोर्याउनुहोस्", done: "पूरा",
      A1: "हेलसिंकी र द्वीपसमूह", A1sub: "A1 · फिनिसमा तपाईंका पहिलो पाइला",
      A2: "तालहरूको क्षेत्र", A2sub: "A2 · दैनिक फिनिस जीवन",
      B1: "ल्यापल्यान्ड", B1sub: "B1 · धाराप्रवाह र स्वाभाविक बोल्नुहोस्",
      search: "पाठ खोज्नुहोस्…", questions: "प्रश्न",
    },
    qx: {
      modeTitle: "आफ्नो क्विज छान्नुहोस्", quick: "छिटो राउन्ड", quickDesc: "१० अनियमित प्रश्न — हरेक पटक फरक।",
      full: "पूर्ण चुनौती", fullDesc: "यस अध्यायका सबै प्रश्न।", questions: "प्रश्न", start: "सुरु गर्नुहोस्",
      combo: "कम्बो", xp: "XP", mc: "बहुविकल्पीय", tf: "सही वा गलत", fill: "खाली ठाउँ भर्नुहोस्",
      translate: "फिनिसमा अनुवाद गर्नुहोस्", tTrue: "सही", tFalse: "गलत", review: "आफ्ना गल्तीहरू हेर्नुहोस्",
      noMistakes: "कुनै गल्ती छैन — täydellistä!", yourAnswer: "तपाईंको उत्तर", best: "उत्कृष्ट", keys: "सुझाव: छान्न १–४, जाँच्न Enter",
      earned: "कमाएको XP", bestCombo: "उत्कृष्ट कम्बो", grouped: "स्तर अनुसार क्विज",
    },
    gx: {
      xp: "कुल XP", rank: "दर्जा", nextRank: "अर्को दर्जासम्म", achievements: "उपलब्धिहरू",
      a_first: "पहिलो पाठ", a_first_d: "आफ्नो पहिलो पाठ पूरा गर्नुहोस्",
      a_ten: "दस पाठ", a_ten_d: "१० पाठ पूरा गर्नुहोस्",
      a_perfect: "पूर्ण अंक", a_perfect_d: "कुनै पनि क्विजमा १००%",
      a_streak: "निरन्तर", a_streak_d: "३ दिनको स्ट्रिक",
      a_words: "शब्द संग्राहक", a_words_d: "२५ शब्द सिक्नुहोस्",
      a_a1: "A1 पूरा", a_a1_d: "सबै A1 पाठ पूरा गर्नुहोस्",
    },
  },
};

export const BIOME_IMG = {
  A1: "https://images.unsplash.com/photo-1568008842610-6642e5afe517?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  A2: "https://images.unsplash.com/photo-1592820983450-e3b66533b1b3?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
  B1: "https://images.unsplash.com/photo-1742075016950-ee955d0527d0?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80",
};

export const RANKS = [0, 300, 900, 1800, 3200];

export function computeXp(progress) {
  const scores = Object.values(progress?.quiz_scores || {});
  return (progress?.completed_lessons || []).length * 50
    + scores.reduce((a, s) => a + s.score * 10, 0)
    + (progress?.mastered_words || []).length * 5;
}

export function rankOf(xp) {
  let i = 0;
  while (i + 1 < RANKS.length && xp >= RANKS[i + 1]) i++;
  return { index: i, floor: RANKS[i], next: RANKS[i + 1] ?? null };
}
